<div class="avatar-wrapper"
     [appPhotoGalleryGroup]="{ clickMode: 'single' }"
     [ngClass]="{ 'avatar-colorful': isColorful }"
     [ngStyle]="{ '--avatar-size': size, '--avatar-color': color }">
  @if (isBlocked) {
    <app-icon class="avatar-blocked">block</app-icon>
  } @else {
    <ng-container *ngTemplateOutlet="notBlocked" />
  }

  <ng-template #notBlocked>
    @if (url && !hasImageError) {
      @if (isPhotoGallery) {
        <img [appPhotoGallery]="{ mimeType: 'image/png', url }"
             [src]="url"
             alt="chat avatar"
             class="click-css"
             (error)="onImgError()">
      } @else {
        <img [src]="url"
             alt="chat avatar"
             (error)="onImgError()">
      }
    } @else {
      <ng-container *ngTemplateOutlet="noUrl" />
    }
  </ng-template>

  <ng-template #noUrl>
    @if (isGroup) {
      <img [src]="DEFAULT_GROUP_ICON" alt="group avatar">
    } @else {
      <ng-container *ngTemplateOutlet="noGroup" />
    }
  </ng-template>

  <ng-template #noGroup>
    @if (title) {
      <span>{{ getInitials(title) }}</span>
    } @else {
      <ng-container *ngTemplateOutlet="noInitials" />
    }
  </ng-template>

  <ng-template #noInitials>
    <img [src]="DEFAULT_PROFILE_ICON" alt="user avatar">
  </ng-template>

  @if (additionalUrl) {
    <img [src]="additionalUrl"
         class="additional-icon {{ additionalClass }}"
         alt="additional icon">
  }

  @if (status && statusClass) {
    <span
      class="absolute bottom-0 right-0 size-[max(8px,calc(var(--avatar-size,24px)*0.3))] rounded-full border-2 border-white"
      [ngClass]="statusClass"
      [attr.title]="'presence_' + status | translate"
    ></span>
  }

  @if (crmService.config.is_new_year) {
    <img src="assets/svgs/icons/santa-claus-hat.svg"
         class="santa-hat"
         alt="santa hat">
  }
</div>
